module.exports = __webpack_public_path__ + "img/tunuve.8e67e53e.png";